import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';

import './index.scss';
import { orange } from '@material-ui/core/colors';
import { Grid } from '@material-ui/core';


const BootstrapInput = withStyles((theme) => ({
  root: {
    ' + ': {
      marginTop: theme.spacing(3),
    },
  },
  formControl: {
    margin: theme.spacing(1),
    //minWidth: 160,
    marginTop: '15px',
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: orange[800],
    border: '1px solid #ff8000',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: orange[800],
      backgroundColor: orange[800],
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  item: {
    width: 200,

  },
}));


export default function Dropdown({ items = [] }) {
  const classes = useStyles();
  const history = useHistory();
  const [option, setOption] = useState('');
  const [selectedItem, setSelectedItem] = useState(items.length > 0 ? items[0] : '');

  const handleChange = (event) => {
    setOption(event.target.value);
  };

  const handleClick = (event) => {
    // const currentTarget = event.target.dataset.value;

    // if (currentTarget === "schedule-modal") {
    //   setIsScheduleModalShow(true);
    // } else if (currentTarget === "remove-modal") {
    //   setIsRemoveModalShow(true);
    // } else if (currentTarget === "preview-modal") {
    //   setIsPreviewModalShow(true);
    // } else if (currentTarget === "delete-modal") {
    //   setIsDeleteModalShow(true);
    // } else if (currentTarget === "edit-tags-modal") {
    //   setIsEditTagsModalShow(true);
    // } else if (currentTarget === "tags-content-redirection") {
    //   history.push("/tagged-content");
    //   window.location.reload();
    // }
  };

  // const handleClose = () => {
  //   setIsPreviewModalShow(false);
  // };

  return (
    <>
      {items.length > 0 ? (
        <Grid style={{marginTop: '10px'}}>
          <FormControl variant="outlined" className={classes.formControl}>
            <Select
              style={{ padding: '2.5px 14px', backgroundColor: '#434343' }}
              native
              label="Synlighed"
              inputProps={{
                name: 'visibility',
                id: 'outlined-synlighed',
              }}
            >
              {
                items.map((item, index) => (
                  <option value={item}>{item}</option>
                ))
              }
            </Select>
          </FormControl>

        </Grid>
      ) : ''}
    </>
  );
}
